import React from 'react';
import Heading1 from '../Heading/Heading1';
import Para1 from '../Paragraph/Paragraph1';
import Button1 from '../Buttons/Button1';
import { Link } from 'react-router-dom';

export default function BoxText(props) {
  return (
    <div
      style={{
        background: 'linear-gradient(to right, #56F444, #55EE44, #48FA8A)', // Gradient background
        padding: '2.5rem 1rem', // Adjusted padding (py-10 px-2)
        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)', // Shadow effect
        borderRadius: '8px', // Rounded corners (rounded-md)
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem', // Space between items
        alignItems: 'center', // Center align content
      }}
    >
      {/* Heading */}
      <div
        style={{
          lineHeight: '1.4', // Adjust line spacing (leading-snug)
          padding: '0 1rem', // Adjusted padding (px-10, md:px-16, lg:px-20)
          width: '100%', // Default width
          maxWidth: '75%', // Limit the width (md:w-3/4)
          textAlign: 'center', // Center text
          margin: '0 auto', // Center content within container
        }}
      >
        <Heading1 heading1={props.heading1} />
      </div>

      {/* Paragraph */}
      <div
        style={{
          color: '#000000', // Black text
          width: '100%',
          maxWidth: '75%', // Limit width (md:w-3/4)
          textAlign: 'center', // Center text
          margin: '0 auto', // Center content within container
        }}
      >
        <Para1 para1={props.para} />
      </div>

      {/* Button */}
      <Link to="/" style={{ margin: '0 auto' }}>
        <Button1 btn1={props.btn1} />
      </Link>
    </div>
  );
}
